import type { DomainEvent } from "../../models/events.ts";
import type { EventTileCoordinates, RandomEventEngineState } from "../../models/randomEvent.ts";
import type { WorldState } from "../../models/worldState.ts";
import { processTileEntry } from "./processTileEntry.ts";

export function applyRandomEventTileEntry(
  state: WorldState,
  enteredTile: EventTileCoordinates,
): {
  randomEvent: RandomEventEngineState;
  events: DomainEvent[];
} {
  const result = processTileEntry(state.randomEvent, enteredTile);
  const events: DomainEvent[] = result.notifications.map((notification) => ({
    type: "RandomEventTileEntered" as const,
    eventId: notification.eventId,
    tile: notification.tile,
  }));

  return {
    randomEvent: result.state,
    events,
  };
}
